import { Link } from "react-router-dom";
import styled from "styled-components";
import { Button } from "../presentation/Button";
import { useAuth } from "react-oidc-context";
import MinesweeperVersusPaths from "~/helpers/constants/MinesweeperVersusPaths";

const HomePageLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  font-family: "Press Start 2P", cursive;

  & > * {
    margin: 5px 0px;
  }
`;

const TopContent = styled.div`
  width: 100%;
  margin-bottom:16px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const MainContentLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  margin-top:64px;
  & > * {
    margin-top:16px;
  }
`;


export const HomePage = () => {
  const auth = useAuth();

  return (
    <HomePageLayout>
      <TopContent>
        {auth.isAuthenticated ? 
          <Button onClick={() => auth.signoutRedirect()}>
            Logout
          </Button> :
          <Button onClick={() => auth.signinRedirect()}>
            Login
          </Button>
        }
      </TopContent>
      <MainContentLayout>
          <Link to={MinesweeperVersusPaths.singleplayerOffline}>
            <Button width={300} >
              Single Player (Offline)
            </Button>
          </Link>
          <Link to={MinesweeperVersusPaths.singleplayerRanked}>
            <Button width={300} disabled={!auth.isAuthenticated}>
              Single Player (Ranked)
            </Button>
          </Link>
          <Link to={MinesweeperVersusPaths.multiplayerClassic}>
            <Button width={300} disabled={!auth.isAuthenticated}>
              Multi Player (Classic)
            </Button>
          </Link>
      </MainContentLayout>
    </HomePageLayout>
  );
};
